import {
  AfterViewInit, Component, ElementRef, QueryList,
  ViewChild, ViewChildren, HostListener
} from '@angular/core';

type Card = {
  title: string;
  subtitle?: string;
  hover?: string;
  img: string;
  imgAlt: string;
  desc?: string;        // overlay text
};

@Component({
    selector: 'app-elevplus-classes',
    templateUrl: './elevplus-classes.component.html',
    styleUrls: ['./elevplus-classes.component.css'],
    standalone: false
})
export class ElevplusClassesComponent implements AfterViewInit {

  @ViewChild('viewport', { static: true } as { static: boolean; read?: any; }) viewport!: ElementRef<HTMLElement>;
  @ViewChildren('cardEl') cardEls!: QueryList<ElementRef<HTMLElement>>;

  cards: Card[] = [
    {
      title: 'Tailored', subtitle: 'For Success',
      img: 'assets/images/ep-sl-1.png',
      imgAlt: 'Student smiling',
      desc: `<ol class"desc">
                <li>Personalized study plans</li>
                <li>Regular progress tracking</li>
                <li>Expert guidance</li>
              </ol>`
    },
    {
      title: 'Interactive', subtitle: 'Lectures',
      img: 'assets/images/ep-sl-2.png',
      imgAlt: 'Team discussion',
      desc: `<ol class"desc">
                <li>Board wise experienced</li>
                <li>teachers Activate prior learning</li>
                <li>High Level to depth of Concepts</li>
                <li>Quick Lecture Summary Video</li>
              </ol>`
    },
    {
      title: 'All Round', subtitle: 'Learning',
      img: 'assets/images/ep-sl-3.png',
      imgAlt: 'Books',
      desc: `<ol class"desc">
                <li>Technological Aids</li>
                <li>Individualized Support</li>
                <li>High Level to depth of Concepts</li>
                <li>Individualized Support</li>
              </ol>`
    },
    {
      title: 'Consistent ', subtitle: 'Assessment',
      img: 'assets/images/ep-sl-4.png',
      imgAlt: 'Online tutoring',
      desc: `<ol class"desc">
                <li>Class Tests</li>
                <li>Home Test</li>
                <li>Unit/Topic Tests</li>
                <li>Full Mock Test</li>
              </ol>`
    },
    {
      title: 'Error Log', subtitle: '& Feedback',
      img: 'assets/images/ep-sl-5.png',
      imgAlt: 'Books',
      desc: `<ol class"desc">
                <li>Parents Teacher Meeting (PTM)</li>
                <li>Self Assessment & Reflection</li>
                <li>Share student progress.</li>
                <li>Highlight Weak & Strong Areas</li>
              </ol>`
    },
    {
      title: 'Full Mocks Tests', subtitle: '& Past Papers',
      img: 'assets/images/ep-sl-6.png',
      imgAlt: 'Books',
      desc: `<ol class"desc">
                <li>Result Analysis Report (RAR) to Error Log to Feedback to PTM</li>
                <li>Free online Practice Test & Video Solution</li>
              </ol>`
    },
    {
      title: 'Analysis', subtitle: 'Feedback,Counselling & Improve',
      img: 'assets/images/ep-sl-7.png',
      imgAlt: 'Books',
      desc: `<ol class"desc">
                <li>Result Analysis Report (RAR)</li>
                <li>Reinforcement of weak areas</li>
                <li>Unit/Topic Tests</li>
                <li>Reinforcement of weak areas</li>
              </ol>`
    }

  ];

  currentIndex = 0;
  private step = 0;
  private positions: number[] = [];
  showOverlayIndex: number | null = null;

  isDragging = false;
private startX = 0;
private scrollStart = 0;

  ngAfterViewInit(): void {
    this.measure();
    const el = this.viewport.nativeElement;

    // track current index while scrolling
    let ticking = false;
    el.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          this.updateCurrentIndex();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  @HostListener('window:resize')
  onResize() { this.measure(); }

  private measure() {
    const el = this.viewport.nativeElement;
    this.positions = this.cardEls.toArray()
      .map(c => c.nativeElement.offsetLeft - el.offsetLeft);
    this.step = this.positions[1] !== undefined
      ? this.positions[1] - this.positions[0]
      : el.clientWidth;
    this.updateCurrentIndex();
  }

  private updateCurrentIndex() {
    const el = this.viewport.nativeElement;
    if (this.step <= 1) { this.currentIndex = 0; return; }
    this.currentIndex = Math.round(el.scrollLeft / this.step);
  }

  goTo(i: number) {
    const el = this.viewport.nativeElement;
    const x = (this.positions[i] !== undefined) ? this.positions[i] : (i * this.step);
    el.scrollTo({ left: x, behavior: 'smooth' });
  }

  prev() { this.goTo(Math.max(0, this.currentIndex - 1)); }
  next() { this.goTo(Math.min(this.cards.length - 1, this.currentIndex + 1)); }

  // overlay: tap/click to toggle (works on mobile); hide when mouse leaves card
  toggleOverlay(i: number) {
    this.showOverlayIndex = this.showOverlayIndex === i ? null : i;
  }
  hideOverlay() { this.showOverlayIndex = null; }

  // keyboard support
  onKeydown(e: KeyboardEvent) {
    if (e.key === 'ArrowLeft') { e.preventDefault(); this.prev(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); this.next(); }
    else if (e.key === 'Home') { e.preventDefault(); this.goTo(0); }
    else if (e.key === 'End') { e.preventDefault(); this.goTo(this.cards.length - 1); }
  }

dragStart(e: PointerEvent) {
  this.isDragging = true;
  const el = this.viewport.nativeElement;
  el.setPointerCapture(e.pointerId);
  this.startX = e.clientX;
  this.scrollStart = el.scrollLeft;
}

dragMove(e: PointerEvent) {
  if (!this.isDragging) return;
  const el = this.viewport.nativeElement;
  const dx = e.clientX - this.startX;
  el.scrollLeft = this.scrollStart - dx;   // drag to scroll
}

dragEnd(e?: PointerEvent) {
  this.isDragging = false;
  if (e) this.viewport.nativeElement.releasePointerCapture(e.pointerId);
}


//Gallery Section
  gal_images = [
    { src: "https://res.cloudinary.com/dlddixhyu/image/upload/v1769013030/2023_020_022_1_qguvff.jpg", title: "Award Ceremony" },
    { src: "https://res.cloudinary.com/dlddixhyu/image/upload/v1769012652/2023_020_034_ospqt0.jpg", title: "Award Ceremony" },
    { src: "https://res.cloudinary.com/dlddixhyu/image/upload/v1769013030/2023_020_040_1_kmobkn.jpg", title: "Award Ceremony" },
    { src: "https://res.cloudinary.com/dlddixhyu/image/upload/v1769013030/2023_020_086_1_pgnkwj.jpg", title: "Award Ceremony" },
    { src: "https://res.cloudinary.com/dlddixhyu/image/upload/v1769013030/2023_020_072_1_cpezhb.jpg", title: "Award Ceremony" },
  ];

  isSliding = false;

  get currentImage() {
    return this.gal_images[this.currentIndex].src;
  }

  get currentTitle() {
    return this.gal_images[this.currentIndex].title;
  }

  changeImage(index: number) {
    if (index !== this.currentIndex) {
      this.isSliding = true; // Start animation
      setTimeout(() => {
        this.currentIndex = index;
        this.isSliding = false; // Reset animation
      }, 300);
    }
  }


}
